import styled from 'styled-components';
import { TextField } from '@material-ui/core';

export const Th = styled.th`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  background: #e9ecef;
`;

export const Td = styled.td`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
`;

export const BuscarRegras = styled(TextField)`
  width: 70%;
  background-color: #fff;
`;
